import { useEffect, useState } from "react";

export const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY;
      setProgress(totalHeight > 0 ? (scrolled / totalHeight) * 100 : 0);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 w-full z-[60]"
      style={{ height: "3px", background: "transparent" }}
    >
      <div
        className="h-full"
        style={{
          width: `${progress}%`,
          background: "linear-gradient(90deg, #7B68EE, #60A5FA, #A78BFA)",
          transition: "width 0.1s linear",
          boxShadow: "0 0 12px rgba(123,104,238,0.5)",
          borderRadius: "0 2px 2px 0",
        }}
      />
    </div>
  );
};
